import { createAction, props } from '@ngrx/store';
import {
  ConnectionState,
  IChatAuth,
  IChatMessage,
  ICustomerUser,
  JoinChatResponse
} from '@care-portals/api-interfaces';

export const ping = createAction(
  '[Chat] Send Ping',
  props<{ customerId: string }>()
);
export const pingSuccess = createAction('[Chat] Ping Success');
export const pingFailure = createAction(
  '[Chat] Ping Failure',
  props<{ error: any }>()
);

export const forwardCS = createAction(
  '[Chat] forward CS',
  props<{ customerId: string }>()
);
export const forwardCSSuccess = createAction('[Chat] forward CS Success');
export const forwardCSFailure = createAction(
  '[Chat] forward CS Failure',
  props<{ error: any }>()
);

export const forwardPH = createAction(
  '[Chat] forward PH',
  props<{ customerId: string }>()
);
export const forwardPHSuccess = createAction('[Chat] forward PH Success');
export const forwardPHFailure = createAction(
  '[Chat] forward PH Failure',
  props<{ error: any }>()
);

export const openChat = createAction(
  '[Chat] Open Chat',
  props<{ customer: ICustomerUser, mode?: 'inbox'|'chat', style?: 'drawer'|'sidebar'}>()
);

export const startChat = createAction('[Chat] Start Chat');

export const startChatSuccess = createAction(
  '[Chat] Start Chat Success',
  props<{
    customer: ICustomerUser;
    response: JoinChatResponse;
  }>()
);

export const startChatFailure = createAction(
  '[Chat] Start Chat Failure',
  props<{ error: any }>()
);

export const refreshToken = createAction('[Chat] Refresh Token');

export const refreshTokenSuccess = createAction(
  '[Chat] Refresh Token Success',
  props<{ auth: IChatAuth }>()
);

export const refreshTokenFailure = createAction(
  '[Chat] Refresh Token Failure',
  props<{ error: any }>()
);

export const connectionStateChanged = createAction(
  '[Chat] Connection State Changed',
  props<{ connectionState: ConnectionState }>()
);

export const chatJoined = createAction(
  '[Chat] Chat Joined',
  props<{ chatId: string; participants: any[] }>()
);

export const chatLeft = createAction(
  '[Chat] Chat Left',
  props<{ participants: any[] }>()
);

export const messageAdded = createAction(
  '[Chat] Message Added',
  props<{ chatId: string; message: IChatMessage }>()
);

export const loadMessages = createAction('[Chat] Load Messages');

export const loadMessagesSuccess = createAction(
  '[Chat] Load Messages Success',
  props<{ chatId: string; messages: Array<IChatMessage> }>()
);

export const loadMessagesFailure = createAction(
  '[Chat] Load Messages Fail',
  props<{ error: any }>()
);

/**
 * `sessionId` scopes a teardown to the chat session that requested it (see
 * `openChat` in the reducer). A chat view whose drawer is still animating out
 * while a newer chat has already opened must not tear down the live session,
 * so it tags its close with the id it was mounted for and the reducer/effects
 * drop it as stale. Omit the id to close whatever is current.
 */
export const removeParticipant = createAction(
  '[Chat] Remove Participant',
  props<{ sessionId?: number }>()
);

export const closeChat = createAction(
  '[Chat] Close Chat',
  props<{ sessionId?: number }>()
);

export const sendMessage = createAction(
  '[Chat] Send Message',
  props<{ chatId: string; message: string, files: any[] }>()
);

export const loadMore = createAction(
  '[Chat] Load More',
  props<{ chatId: string; }>()
);
export const loadMoreSuccess = createAction(
  '[Chat] Load More Success',
  props<{ chatId: string; messages: IChatMessage[] }>()
);
export const loadMoreFailure = createAction(
  '[Chat] Load More Failure',
  props<{ error: any; }>()
);

export const updateChatCount = createAction(
  '[Chat] Get Chat Count',
  props<{ chatId: string; count: number }>()
);

export const nullAction = createAction('[Chat] Null');

/// VIDEO ACTIONS

export const joinVideo = createAction('[Chat] Join Video Room',   props<{ customerId: string }>()
);

export const joinVideoSuccess = createAction(
  '[Chat] Join Video Room Success',
  props<{ hostUrl: string, joinUrl: string }>()
);

export const joinVideoFailure = createAction(
  '[Chat] Join Video Room Failure',
  props<{ error: Error }>()
);

